import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";

export default function otpPreAssesment(
  ccFormValue: Ref<FormCC>,
  prop: any,
  page3Overlay: Ref<boolean>,
  creditLimit: Ref<string>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page3Overlay.value = true;
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    name: ccFormValue.value.basicInformation.name,
    icNo: ccFormValue.value.basicInformation.idNo,
    dateOfBirth: ccFormValue.value.basicInformation.dob,
    cardBusinessCode: prop.cardId,
    nationalityCode: ccFormValue.value.basicInformation.nationality,
    phoneNo:
      ccFormValue.value.basicInformation.countryCode +
      ccFormValue.value.basicInformation.mobileNo,
    grossIncome: ccFormValue.value.basicInformation.grossSalary.toString(),
    netIncome: ccFormValue.value.basicInformation.netSalary.toString(),
    refNo: ccFormValue.value.refNo,
  };
  MasterService.preAssesment(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        page3Overlay.value = false;
        ccFormValue.value.preAss.webFormRequestId =
          res.data.responseModel.webFormRequestId;
        ccFormValue.value.dsrBurst = res.data.responseModel.dSRStatus;
        ccFormValue.value.dropOffStep = 5;
        creditLimit.value = res.data.responseModel.preAssessLimit;
        ccFormValue.value.ctosScore = res.data.responseModel.ctosScore;
        ccFormValue.value.ekyc.preStatus =
          res.data.responseModel.preAssessStatus;
        if (res.data.responseModel.preAssessStatus == "DECLINED") {
          jumpStep(14, "denied2", "3");
        } else {
          jumpStep(4, "", "3");
        }
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page3Overlay.value = false;
      ccFormValue.value.ekyc.preStatus = "DOWN";
      jumpStep(4, "", "3");
      // jumpStep(14, "denied2", "3");
    });
}
